export const identityData: Record<string, string[]> = {
    'Ethnic Groups': [
        'Ababda', 'Adjoukrou', 'Adara', 'Afemai', 'Afar', 'African American', 'Afrikaner',
        'Agaw', 'Aja', 'Aka', 'Akuapem', 'Akwamu', 'Akyem', 'Akan', 'Alur',
        'Amazigh', 'Amhara', 'Anuak', 'Arab', 'Arbore', 'Arma', 'Ashanti', 'Azande',
        'Afro-Brazilian', 'Black Brazilian', 'Afro-Canadian', 'Black Canadian', 'Afro-Caribbean', 'Afro-European', 'Afro-Latinx',
        'Babongo', 'Baga', 'Baka', 'Bakiga', 'Bakingo', 'Bakonjo', 'Bakongo',
        'Bakuda', 'Bakutu', 'Bakwel', 'Balanta', 'Bambara/Bamana', 'Bamiléké', 'Bamum', 'Banda', 'Bangala',
        'Banyankole', 'Banyoro', 'Baoulé', 'Bariba', 'Bari', 'Bassa', 'Bassari', 'Baster',
        'Basotho', 'Batswana', 'Batooro', 'Batwa', 'Bedik', 'Bedouin', 'Beja', 'Bemba',
        'Bembe', 'Bena', 'Berber', 'Berom', 'Bete', 'Beti', 'Bijago', 'Bilen', 'Binji',
        'Black American', 'Black British', 'Bobo', 'Boma', 'Borana', 'Bozo', 'Bubi', 'Bukusu', 'Bwa',
        'Cape Malay', 'Chaga', 'Chakosi', 'Chaoui', 'Chewa', 'Chenoua', 'Chokwe', 'Chopi',
        'Copts', 'Cajun', 'Cherokee', 'Creole', 'Dougla',
        'Daasanach', 'Dagomba', 'Damara', 'Dan', 'Dendi', 'Dey', 'Diola/Jola', 'Digo', 'Dinka', 'Dogon',
        'Dorze', 'Duala', 'Dyula/Dioula',
        'Edo', 'Efik', 'Egun', 'Ejagham', 'Eket', 'Elgeyo', 'Embu', 'Eton', 'European Africans', 'Ewe',
        'Fali', 'Fang', 'Fante', 'Fon', 'Fulani/Peul', 'Fur',
        'Ga', 'Gabra', 'Ganda', 'Gbandi', 'Gbaya', 'Gogo', 'Gola', 'Gonja', 'Grebo', 'Griqua', 'Gullah Geechie', 'Gurma',
        'Gurage', 'Guro', 'Gurunsi', 'Gusii', 'Gwari',
        'Hadza', 'Hamar', 'Harari', 'Haratin', 'Hausa', 'Haya', 'Hehe', 'Hemba', 'Herero',
        'Himba', 'Holoholo', 'Hunde', 'Hutu',
        'Ibibio', 'Idoma', 'Igala', 'Igbo', 'Ijaw', 'Iraqw', 'Isoko', 'Iteso', 'Itsekiri',
        'Jibbali', 'Jukun',
        'Kabyle', 'Kabye', 'Kalenjin', 'Kamba', 'Kanembu', 'Kaonde', 'Karamojong', 'Karo',
        'Kikuyu', 'Khassonke', 'Khoikhoi', 'Kipsigis', 'Kirdi', 'Kissi', 'Kituba', 'Kongo', 'Konso', 'Kota', 'Kpelle',
        'Krahn', 'Krio', 'Krobo', 'Kru', 'Kunama', 'Kuranko', 'Kuria', 'Kuvale', 'Kwele',
        'Laka', 'Langi', 'Lele', 'Lemba', 'Lengola', 'Limba', 'Lobi', 'Loma/Lorma', 'Lovedu', 'Lozi',
        'Luba', 'Lugbara', 'Luhya', 'Luo', 'Lunda', 'Luvale',
        'Maasai', 'Makonde', 'Makua', 'Malinke/Mandinka', 'Mamprusi', 'Mano', 'Manyika', 'Maragoli', 'Maroon',
        'Mbulu', 'Mende', 'Meru', 'Mongo', 'Mossi', 'Mozabite', 'Mursi',
        'Nama', 'Nandi', 'Ndebele', 'New Afrikan', 'Ngoni', 'Nubi', 'Nubian', 'Nuer', 'Nupe', 'Nyakyusa',
        'Nyamwezi', 'Nyaturu', 'Nzema',
        'Ogoni', 'Oromo', 'Ovambo',
        'Pare', 'Pedi', 'Pokot',
        'Rendille', 'Riffian',
        'Saho', 'Samburu', 'San (Bushmen)', 'Sebei', 'Seminole', 'Sena', 'Senufo', 'Serer', 'Shambaa',
        'Shangaan', 'Shilha', 'Shona', 'Sidama', 'Siwi', 'Somali', 'Soninke/Sarahule', 'Songhai', 'Sotho', 'Soulaan',
        'Sukuma', 'Susu', 'Swahili', 'Swazi',
        'Temne', 'Tigray', 'Tigre', 'Tiv', 'Tonga', 'Toubou', 'Tsonga', 'Tswana', 'Tumbuka', 'Tuareg',
        'Turkana', 'Tutsi', 'Twa',
        'Urhobo',
        'Vai', 'Venda',
        'Welayta', 'Wolof',
        'Xhosa',
        'Yao', 'Yoruba',
        'Zaramo', 'Zarma', 'Zenata', 'Zouaoua', 'Zulu', 'Zway',
    ],
    'Religions': [
        'Christianity', 'Islam', 'Sunni Islam', 'Shia Islam', 'Sufi Islam', 'Mouride Sufi', 'Tijaniyya Sufi', 'Baye Fall', 'Nation of Islam',
        'Catholicism', 'Protestantism', 'Orthodox Christianity', 'Pentecostalism',
        'Traditional African', 'Voodoo/Vodun', 'Ifa', 'Santeria', 'Candomblé', 'Hoodoo', 'Waaqeffannaa',
        'Judaism', 'Rastafarianism', 'Buddhism', 'Hinduism',
        'Non-religious', 'Spiritual but not religious', 'Agnostic', 'Atheist',
    ],
    'Music': [
        'Abakuá', 'African Traditional', 'Afro-Jazz', 'Afro-R&B', 'Afro-Soul', 'Afro-Tech',
        'Afro-fusion', 'Afrobeat', 'Afrobeats', 'Afrodrill', 'Afrohouse', 'Afropop', 'Afroswing', 'Agbadza', 'Altiplano',
        'Alternative', 'Alté', 'Amapiano', 'Andalusi Classical', 'Apala', 'Asakaa', 'Assiko',
        'Axé',
        'Baajuni', 'Bacardi House', 'Bachata', 'Baile Funk', 'Bambuco', 'Batida', 'Benga',
        'Biguine', 'Bikutsi', 'Blues', 'Boeremusiek', 'Bolero', 'Bomba', 'Bongo Flava',
        'Boom Bap', 'Bossa Nova', 'Bouyon', 'Brega', 'Bubblegum (SA 80s)', 'Bullerengue',
        'Cadence-lypso', 'Calypso', 'Candombe', 'Cape Jazz', 'Cha-cha-chá', 'Chaabi',
        'Chacarera', 'Chakacha', 'Champeta', 'Chicha', 'Chimurenga', 'Choro', 'Chutney',
        'Chutney-Soca', 'Classical', 'Club', 'Congolese Rumba', 'Conscious Rap', 'Coupe-Decale',
        'Cuarteto', 'Cumbia',
        'Dance', 'Dancehall', 'Danzón', 'Deep House', 'Desert Blues', 'Drill', 'Dub',
        'EDM', 'Electronic', 'Ennanga Soul', 'Ethio-Jazz',
        'Famo', 'Festejo', 'Folk', 'Forró', 'Frevo', 'Fuji', 'Funk', 'Funk Carioca', 'Funaná',
        'Gaita Zuliana', 'Gengetone', 'Genge', 'Gnawa', 'Gospel', 'Gqom', 'Griot', 'Guajira',
        'Gumbe',
        'Hagallah', 'Highlife', 'Hip-Hop', 'Hipco', 'Hiplife', 'House', 'Huayno',
        'Indie', 'Isicathamiya', 'Ivoirian Drill',
        'Jazz', 'Jeel', 'Jit', 'Joropo', 'Juju',
        'Kadongo Kamu', 'Kalindula', 'Kapuka', 'Kasi Rap', 'Kidandali', 'Kidumakuru', 'Kizomba',
        'Kompa', 'Kuduro', 'Kwassa Kwassa', 'Kwaito', 'Kwela',
        'Landó', 'Lekompo', 'Logoby', 'Lovers Rock', 'Lucumí',
        'Makossa', 'Malhun', 'Mambo', 'Maracatu', 'Marabi', 'Maringa', 'Marinera', 'Marrabenta',
        'Maskandi', 'Mbalax', 'Mbaqanga', 'Mbube', 'Mento', 'Merengue', 'Metal', 'Méringue',
        'Mezwed', 'Milonga', 'Mizik Rasin', 'Motswako', 'Mutuashi', 'Murga',
        'Ndombolo', 'Neo-Afrosoul', 'Neo-Soul', 'Nueva Canción', 'Nuuba', 'Nyabinghi',
        'Ohangla', 'Old School Hip-Hop',
        'Pagode', 'Palm-wine music', 'Palo', 'Parang', 'Pasillo', 'Plena', 'Pop', 'Porro',
        'Punk',
        'Qaraami',
        'R&B', 'Raï', 'Rap', 'Rap Gasy', 'Rapso', 'Rara', 'Reggae', 'Reggaeton', 'Rock',
        'Rocksteady', 'Rumba',
        'Sakara', 'Salsa', 'Samba', 'Sanjuanito', 'Sebene', 'Seis', 'Senerap', 'Sertanejo',
        'Shangaan Electro', 'Singeli', 'Ska', 'Soca', 'Somali Jazz', 'Son Cubano',
        'Soul', 'South African Jazz', 'Soukous', 'Steelpan', 'Stambeli', 'Sudanese Jazz',
        'Sungura',
        'Taarab', 'Takamba', 'Tango', 'Tcheke', 'Timba', 'Trap', 'Tropicalia',
        'UK Drill',
        'Vallenato', 'Vodou Jazz',
        'Wassoulou', 'Way-Way', 'World Music',

        'Zamrock', 'Zilipendwa', 'Zouk', 'Zouglou',
    ],
    'Beliefs': [
        'Pan-Africanism', 'Ubuntu', 'Social Justice', 'Environmentalism',
        'Feminism', 'Black Lives Matter', 'Afrofuturism', 'Decolonization',
        'African Renaissance', 'Cultural Preservation', 'Traditional Values',
        'Progressivism', 'Conservatism', 'Liberalism', 'Socialism',
        'Black Excellence', 'Community First', 'Education Reform', 'Economic Empowerment',
        'Anti-Racism', 'Intersectionality', 'Indigenous Rights', 'Diaspora Unity',
        'Humanism', 'Secularism', 'Nationalism', 'Globalism',
        'Afrocentrism', 'LGBT Rights', 'Negritude', 'Zamint',
    ],
    'Occupations': [
        'Student', 'Artist', 'Designer', 'Developer', 'Engineer', 'Entrepreneur',
        'Teacher', 'Healthcare Worker', 'Nurse', 'Doctor', 'Dentist',
        'Musician', 'Producer', 'DJ', 'Writer', 'Poet', 'Journalist',
        'Photographer', 'Videographer', 'Content Creator', 'Influencer',
        'Business Analyst', 'Accountant', 'Lawyer', 'Consultant',
        'Chef', 'Fashion Designer', 'Makeup Artist', 'Barber', 'Stylist',
        'Athlete', 'Coach', 'Trainer', 'Dancer', 'Actor',
        'Architect', 'Civil Servant', 'Non-profit Worker', 'Social Worker',
        'Scientist', 'Researcher', 'Academic', 'Professor',
        'Sales Professional', 'Marketing Professional', 'HR Professional',
        'Farmer', 'Agricultural Worker', 'Trader', 'Merchant',
    ],
    'Interests': [
        'Music', 'Art', 'Fashion', 'Tech', 'Sports', 'Fitness',
        'Reading', 'Writing', 'Poetry', 'Literature', 'History',
        'Travel', 'Photography', 'Film', 'Cinema', 'Theater',
        'Dance', 'Cooking', 'Food', 'Gaming', 'Anime',
        'Politics', 'Activism', 'Volunteering', 'Community Service',
        'Entrepreneurship', 'Business', 'Finance', 'Investing',
        'Nature', 'Environment', 'Wildlife', 'Hiking', 'Camping',
        'Yoga', 'Meditation', 'Spirituality', 'Philosophy',
        'Languages', 'Culture', 'Heritage', 'Traditions',
        'Science', 'Technology', 'Innovation', 'AI', 'Crypto',
        'Beauty', 'Skincare', 'Wellness', 'Mental Health',
        'Social Media', 'Podcasts', 'YouTube', 'TikTok',
        'Cars', 'Motorcycles', 'Aviation', 'Space',
    ],
};

export const identityCategories = Object.keys(identityData);

// ── Canonical category colour tokens ──────────────────────────────────────────
// Single source of truth used by IdentityModal, IdentityExpansionModal,
// ProfileSetupScreen, ProfileScreen, UserDetailModal, and OnboardingIdentityScreen.
export const categoryStyles: Record<
  string,
  { bg: string; text: string; border: string; gradient: string }
> = {
  'Ethnic Groups': {
    bg: 'bg-orange-500/10',
    text: 'text-orange-600 dark:text-orange-400',
    border: 'border-orange-500/30',
    gradient: 'linear-gradient(135deg, #F39C12 0%, #E74C3C 100%)',
  },
  'Music': {
    bg: 'bg-green-500/10',
    text: 'text-green-600 dark:text-green-400',
    border: 'border-green-500/30',
    gradient: 'linear-gradient(135deg, #00b09b 0%, #96c93d 100%)',
  },
  'Beliefs': {
    bg: 'bg-teal-500/10',
    text: 'text-teal-600 dark:text-teal-400',
    border: 'border-teal-500/30',
    gradient: 'linear-gradient(135deg, #2193b0 0%, #6dd5ed 100%)',
  },
  'Religions': {
    bg: 'bg-purple-500/10',
    text: 'text-purple-600 dark:text-purple-400',
    border: 'border-purple-500/30',
    gradient: 'linear-gradient(135deg, #8e44ad 0%, #a18cd1 100%)',
  },
  'Interests': {
    bg: 'bg-red-400/10',
    text: 'text-red-500 dark:text-red-300',
    border: 'border-red-400/30',
    gradient: 'linear-gradient(135deg, #ff758c 0%, #ff7eb3 100%)',
  },
  'Occupations': {
    bg: 'bg-blue-500/10',
    text: 'text-blue-600 dark:text-blue-400',
    border: 'border-blue-500/30',
    gradient: 'linear-gradient(135deg, #4478ea 0%, #2d1ef1 100%)',
  },
};

/**
 * Reverse-lookup: given a tag string, return its parent category name.
 *
 * Matching is tolerant of the variations users actually have stored for the
 * dual-name ethnic/religious groups (e.g. "Malinke/Mandinka"): it accepts a
 * reversed order ("Mandinka/Malinke") and either half on its own ("Mandinka").
 * Without this, such variants miss the exact match and fall through to the
 * "Interests" default — which is why a Mandinka tag rendered pink instead of
 * the Ethnic Groups orange.
 */
export const getCategoryByTag = (tag: string): string => {
  const cleanTag = tag?.trim();
  if (!cleanTag) return 'Interests';
  const lower = cleanTag.toLowerCase();
  const inputHalves = lower.includes('/')
    ? lower.split('/').map(s => s.trim()).filter(Boolean).sort()
    : null;

  for (const [category, tags] of Object.entries(identityData)) {
    for (const t of tags) {
      const tl = t.toLowerCase();
      if (tl === lower) return category;
      if (tl.includes('/')) {
        const halves = tl.split('/').map(s => s.trim()).filter(Boolean);
        // Single half name (e.g. "Mandinka" → "Malinke/Mandinka")
        if (halves.includes(lower)) return category;
        // Slash name in any order (e.g. "Mandinka/Malinke" → "Malinke/Mandinka")
        if (inputHalves && halves.slice().sort().join('|') === inputHalves.join('|')) return category;
      }
    }
  }
  return 'Interests'; // default fallback
};
